import { useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';

/**
 * Wraps a given callback in a cancelable, debounced function. The debounced
 * callback is automatically cancelled if the callback reference changes or the
 * component unmounts.
 * @param callback callback function to debounce
 * @param debounceMs debounce milliseconds
 * @param options debounce options such as leading or trailing behavior
 * @returns a cancelable, debounced function
 */
export function useDebouncedCallback(callback, debounceMs) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$leading = options.leading,
    leading = _options$leading === void 0 ? false : _options$leading,
    _options$trailing = options.trailing,
    trailing = _options$trailing === void 0 ? true : _options$trailing,
    maxWait = options.maxWait;
  var debouncedCallback = useMemo(() => debounce(callback, debounceMs, maxWait != null ?
  // lodash checks `'maxWait' in options`
  // and lower clamps to the debounce if it exists at all
  {
    leading,
    trailing,
    maxWait
  } : {
    leading,
    trailing
  }), [callback, debounceMs, leading, trailing, maxWait]);
  useEffect(() => () => debouncedCallback.cancel(), [debouncedCallback]);
  return debouncedCallback;
}
export default useDebouncedCallback;
//# sourceMappingURL=useDebouncedCallback.js.map